import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { Notification } from 'src/app/notification/models/notification.model';
import {
  selectNotificationPageLoading,
  selectNotificationShowInitWaitingMessage,
  selectNotificationsPage,
} from '../_selectors/notification.selectors';

export class NotificationDataSource extends BaseDataSource {
  private _notifications: Notification[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();
    this.loading$ = this.store.select(selectNotificationPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectNotificationShowInitWaitingMessage);
    this.store
      .pipe(select(selectNotificationsPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._notifications = res.items;
        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get notifications() {
    return this._notifications;
  }

  set notifications(notifications) {
    this._notifications = notifications;
  }
}
